import { Modal } from "antd";
// import { CheckOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import BrandButton from "@/components/BrandButton";
import WarningIcon from "@/assets/warning.svg?react";
import {
  //  RESET_HOURS,
  type ResetHours,
} from "./constants";

export function ResetSecretModal({
  open,
  // hours,
  confirming = false,
  // onHoursChange,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  hours: ResetHours;
  confirming?: boolean;
  onHoursChange: (hours: ResetHours) => void;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      centered
      width={560}
      footer={null}
      onCancel={confirming ? undefined : onCancel}
      styles={{ body: { padding: "8px 8px 4px" } }}
    >
      <div className="flex flex-col gap-5">
        <div className="flex items-start gap-5">
          <WarningIcon className="size-7 shrink-0 text-[#F77234]" />
          <div className="flex flex-col gap-5">
            <p className="m-0 text-lg font-medium leading-[25px] text-primary">
              {t("credentials.resetTitle")}
            </p>
            <p className="m-0 text-sm leading-6 text-primary">
              {t("credentials.resetConfirm")}
            </p>
            {/* <div className="flex flex-nowrap gap-2">
              {RESET_HOURS.map((h) => {
                const active = hours === h;
                return (
                  <button
                    key={h}
                    type="button"
                    disabled={confirming}
                    onClick={() => onHoursChange(h)}
                    className="flex h-9.5 shrink-0 cursor-pointer items-center bg-black/2 gap-1 rounded-[14px] px-3 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    <span
                      className={`flex size-4 items-center justify-center rounded-full text-[10px] ${
                        active
                          ? "bg-accent text-white"
                          : "border border-line bg-white text-transparent"
                      }`}
                    >
                      <CheckOutlined />
                    </span>
                    {t("credentials.resetHours", { count: h })}
                  </button>
                );
              })}
            </div> */}
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-1">
          <BrandButton
            variant="outline"
            disabled={confirming}
            onClick={onCancel}
          >
            {t("common.cancel")}
          </BrandButton>
          <BrandButton
            variant="danger"
            disabled={confirming}
            onClick={onConfirm}
          >
            {t("credentials.confirmReset")}
          </BrandButton>
        </div>
      </div>
    </Modal>
  );
}
